const COOKIE_NAME = 'member_color_mode';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function readColorModeCookie() {
    const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export function writeColorModeCookie(mode, remember) {
    const lifetime = remember ? `; max-age=${COOKIE_MAX_AGE_SECONDS}` : '';
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=${mode}; path=/${lifetime}; SameSite=Lax${secure}`;
}

export function currentColorMode() {
    return document.documentElement.getAttribute('data-color-mode');
}

export function applyColorMode(mode) {
    document.documentElement.setAttribute('data-color-mode', mode);
}

export function osColorMode() {
    if (!window.matchMedia) {
        return null;
    }
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
    }
    return null;
}
